// this.popup = window.open(
//     "https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=86f1r0asmt8600&redirect_uri=" +
//     redirectUri +
//     "&scope=r_liteprofile%20r_emailaddress%20w_member_social",
//     "popup",
//     "width=527,height=582"
// );

// Might need to move to more general util file.
function getFullUrlPath(location) {
    const isHttps = location.protocol === "https:";
    return (
        location.protocol +
        "//" +
        location.hostname +
        ":" +
        (location.port || (isHttps ? "443" : "80")) +
        (/^\//.test(location.pathname)
            ? location.pathname
            : "/" + location.pathname)
    );
}

function parseQueryString(str) {
    let obj = {};
    let key;
    let value;
    (str || "").split("&").forEach(keyValue => {
        if (keyValue) {
            value = keyValue.split("=");
            key = decodeURIComponent(value[0]);
            obj[key] = !!value[1] ? decodeURIComponent(value[1]) : true;
        }
    });
    return obj;
}

function objectExtend(a, b) {
    // Don't touch 'null' or 'undefined' objects.
    if (a == null || b == null) {
        return a;
    }

    Object.keys(b).forEach(function (key) {
        if (Object.prototype.toString.call(b[key]) == "[object Object]") {
            if (Object.prototype.toString.call(a[key]) != "[object Object]") {
                a[key] = b[key];
            } else {
                a[key] = objectExtend(a[key], b[key]);
            }
        } else {
            a[key] = b[key];
        }
    });

    return a;
}

function isUndefined(value) {
    return typeof value === 'undefined'
}

export default class OAuthPopup {
    constructor(url, name, popupOptions) {
        this.popup = null
        this.url = url
        this.name = name
        this.popupOptions = popupOptions
    }

    open(redirectUri, skipPooling) {
        try {
            this.popup = window.open(this.url, this.name, this._stringifyOptions());
            if (this.popup && this.popup.focus) {
                this.popup.focus();
            }

            if (skipPooling) {
                return Promise.resolve();
            } else {
                return this.pooling(redirectUri);
            }
        } catch (e) {
            return Promise.reject(new Error("OAuth popup error occurred"));
        }
    }

    pooling(redirectUri) {
        return new Promise((resolve, reject) => {
            const redirectUriParser = document.createElement("a");
            redirectUriParser.href = redirectUri;
            const redirectUriPath = getFullUrlPath(redirectUriParser);

            let poolingInterval = setInterval(() => {
                if (
                    !this.popup ||
                    this.popup.closed ||
                    this.popup.closed === undefined
                ) {
                    clearInterval(poolingInterval);
                    poolingInterval = null;
                    reject(new Error("Auth popup window closed"));
                }

                try {
                    const popupWindowPath = getFullUrlPath(this.popup.location);
                    console.log("***&*&*^*&&%^&*(", redirectUriPath, popupWindowPath)

                    if (popupWindowPath === redirectUriPath) {
                        if (this.popup.location.search || this.popup.location.hash) {
                            const query = parseQueryString(
                                this.popup.location.search.substring(1).replace(/\/$/, "")
                            );
                            const hash = parseQueryString(
                                this.popup.location.hash.substring(1).replace(/[\/$]/, "")
                            );

                            let params = objectExtend({}, query);
                            params = objectExtend(params, hash);
                            if (params.error) {
                                console.log("params.error is: ", params.error);
                                reject(new Error(params.error));
                            } else {
                                console.log("resolve is: ", params);
                                resolve(params);
                            }
                        } else {
                            reject(
                                new Error(
                                    "OAuth redirect has occurred but no query or hash parameters were found."
                                )
                            );
                        }

                        clearInterval(poolingInterval);
                        poolingInterval = null;
                        this.popup.close();
                    }
                } catch (e) {
                    // Ignore DOMException: Blocked a frame with origin from accessing a cross-origin frame.
                    // console.error("!!!exception is: ", e);
                }
            }, 250);
        });
    }

    _stringifyOptions() {
        let options = []
        for (var optionKey in this.popupOptions) {
            if (!isUndefined(this.popupOptions[optionKey])) {
                options.push(`${optionKey}=${this.popupOptions[optionKey]}`)
            }
        }
        console.log("_stringifyOptions", options.join(","));
        return options.join(',')
    }
}  


// WEBPACK FOOTER //
// ./src/utils/oauth.js